import { queryOptions } from '@tanstack/react-query';
import { assetsUrl } from '../util/constants';
import { apiRequest } from '../util/apiRequest';

function courseDocumentQueryOptions(courseId) {
   return queryOptions({
      queryKey: ['courseDocument', courseId],
      queryFn: () => {
         return fetch(
            `${assetsUrl}/secure/course/${courseId}/courseDocument.json`,
            {
               headers: {
                  // to do... general API/content request function that doesn't need to JSON.parse
                  Authorization: `Bearer ${
                     JSON.parse(
                        sessionStorage.getItem('eiauth-accessTokenResponse')
                     )?.token
                  }`,
               },
            }
         ).then((res) => res.json());
      },
      staleTime: Infinity,
      gcTime: 1000 * 60 * 60 * 24,
   });
}

function courseProgressQueryOptions(courseId) {
   return queryOptions({
      queryKey: ['courseProgress', courseId],
      queryFn: () =>
         apiRequest({
            path: `/course/progress/${courseId}`,
         }),
      staleTime: 1000 * 60 * 60 * 3,
      gcTime: 1000 * 60 * 60 * 3,
   });
}

export { courseDocumentQueryOptions, courseProgressQueryOptions };
